// src/AdminNav.tsx
// Shared header + tab bar for the admin pages — real routes, not
// in-component tab state, so each is directly linkable/bookmarkable and
// back-button-navigable. Only "All authors" exists for now.
import { Link } from 'react-router-dom';

export function AdminNav({ active }: { active: 'authors' }) {
  return (
    <>
      <Link to="/dashboard" className="page-back-link">← Dashboard</Link>
      <h1>Admin</h1>
      <nav className="admin-tabs">
        <Link className={`admin-tab${active === 'authors' ? ' admin-tab-active' : ''}`} to="/dashboard/admin">
          All authors
        </Link>
      </nav>
    </>
  );
}
